import { type GetterTree } from 'vuex';

import { type IAgreementState } from './types';

export const GET_MOST_RECENT_CDA = 'getMostRecentCDA';

export const getters: GetterTree<IAgreementState, unknown> = {
    [GET_MOST_RECENT_CDA]: (_state) => {
        return (leadId: number): number => {
            return _state.mostRecentCDA.get(leadId);
        };
    }
};
